import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { useEffect } from 'react';

import LoginPage from './pages/Login';
import DashboardPage from './pages/Dashboard';
import ProductsPage from './pages/Products';
import OrdersPage from './pages/Orders';
import StockPage from './pages/Stock';
import WarehousesPage from './pages/Warehouses';
import CarriersPage from './pages/Carriers';
import PickingPage from './pages/Picking';
import PackingPage from './pages/Packing';
import ShippingPage from './pages/Shipping';
import FreightPage from './pages/Freight';
import TrackingPage from './pages/Tracking';
import ReturnsPage from './pages/Returns';
import OccurrencesPage from './pages/Occurrences';
import IntegrationsPage from './pages/Integrations';
import ReportsPage from './pages/Reports';
import UsersPage from './pages/Users';
import AuditPage from './pages/Audit';
import SettingsPage from './pages/Settings';
import OrderDetailPage from './pages/OrderDetail';
import DashboardLayout from './components/DashboardLayout';
import ModulePageWrapper from './components/ModulePageWrapper';

function HomeRedirect() {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      navigate(isAuthenticated ? '/dashboard' : '/login', { replace: true });
    }
  }, [isAuthenticated, loading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
    </div>
  );
}

function Protected({ children }: { children: React.ReactNode }) {
  return <DashboardLayout>{children}</DashboardLayout>;
}

function ModuleRoute({ children }: { children: React.ReactNode }) {
  return (
    <Protected>
      <ModulePageWrapper>{children}</ModulePageWrapper>
    </Protected>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomeRedirect />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<Protected><DashboardPage /></Protected>} />
      <Route path="/cadastros" element={<Navigate to="/products" replace />} />
      <Route path="/oms" element={<Navigate to="/orders" replace />} />
      <Route path="/wms" element={<Navigate to="/picking" replace />} />
      <Route path="/tms" element={<Navigate to="/freight" replace />} />
      <Route path="/operacoes" element={<Navigate to="/returns" replace />} />
      <Route path="/sistema" element={<Navigate to="/integrations" replace />} />
      <Route path="/products" element={<ModuleRoute><ProductsPage /></ModuleRoute>} />
      <Route path="/orders" element={<ModuleRoute><OrdersPage /></ModuleRoute>} />
      <Route path="/stock" element={<ModuleRoute><StockPage /></ModuleRoute>} />
      <Route path="/warehouses" element={<ModuleRoute><WarehousesPage /></ModuleRoute>} />
      <Route path="/carriers" element={<ModuleRoute><CarriersPage /></ModuleRoute>} />
      <Route path="/picking" element={<ModuleRoute><PickingPage /></ModuleRoute>} />
      <Route path="/packing" element={<ModuleRoute><PackingPage /></ModuleRoute>} />
      <Route path="/shipping" element={<ModuleRoute><ShippingPage /></ModuleRoute>} />
      <Route path="/freight" element={<ModuleRoute><FreightPage /></ModuleRoute>} />
      <Route path="/tracking" element={<ModuleRoute><TrackingPage /></ModuleRoute>} />
      <Route path="/returns" element={<ModuleRoute><ReturnsPage /></ModuleRoute>} />
      <Route path="/occurrences" element={<ModuleRoute><OccurrencesPage /></ModuleRoute>} />
      <Route path="/integrations" element={<ModuleRoute><IntegrationsPage /></ModuleRoute>} />
      <Route path="/reports" element={<ModuleRoute><ReportsPage /></ModuleRoute>} />
      <Route path="/users" element={<ModuleRoute><UsersPage /></ModuleRoute>} />
      <Route path="/audit" element={<ModuleRoute><AuditPage /></ModuleRoute>} />
      <Route path="/settings" element={<ModuleRoute><SettingsPage /></ModuleRoute>} />
      <Route path="/orders/:id" element={<ModuleRoute><OrderDetailPage /></ModuleRoute>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
